import React from "react";
import { IconProps } from "./dto";

export function UserCheckIcon(props: IconProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.6666 56V50.6667C42.6666 47.8377 41.5428 45.1246 39.5424 43.1242C37.542 41.1238 34.8289 40 32 40H13.3333C10.5043 40 7.79121 41.1238 5.79082 43.1242C3.79043 45.1246 2.66663 47.8377 2.66663 50.6667V56M45.3333 29.3333L50.6666 34.6667L61.3333 24M33.3333 18.6667C33.3333 24.5577 28.5577 29.3333 22.6666 29.3333C16.7756 29.3333 12 24.5577 12 18.6667C12 12.7756 16.7756 8 22.6666 8C28.5577 8 33.3333 12.7756 33.3333 18.6667Z" stroke={props.color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}